__turbopack_context__.v({
  "badgeContainer": "Nwu2FW_badgeContainer",
  "body": "Nwu2FW_body",
  "collectionObject": "Nwu2FW_collectionObject",
  "gridView": "Nwu2FW_gridView",
  "image": "Nwu2FW_image",
  "imageWrapper": "Nwu2FW_imageWrapper",
  "link": "Nwu2FW_link",
  "location": "Nwu2FW_location",
  "noImageSvg": "Nwu2FW_noImageSvg",
  "title": "Nwu2FW_title",
  "transparentBackground": "Nwu2FW_transparentBackground",
});
